import parseHtml from 'html-react-parser';
import DesktopImage from './images/business-main-desktop.png';
import MobileImage from './images/business-main-mobile.png';

export const ANXIETY_TREATMENT_DES_1 = 'The professionals at Cerebral';
export const ANXIETY_TREATMENT_DES_2 =
  'can provide a medical diagnosis and appropriate treatment options to help you take control of your mental health.';
export const CBT_DES_1 =
  'CBT helps identify specific challenges in your thought patterns and develop skills to respond to them more effectively.';
export const CBT_DES_2 =
  'One of the most common and effective forms of talk therapy.';

export const DEPRESSION_TREATMENT_OPTIONS = [
  {
    title: 'Highly-rated therapists',
    description: parseHtml(
      '<p>We thoroughly vet each of our therapists and only invite select practitioners to join Cerebral.' +
        ' 99% of our therapists have a <strong>4.8 approval rating or higher</strong> from their clients.</p>'
    )
  },
  {
    title: 'Cognitive behavioral therapy (CBT)',
    description:
      'CBT helps identify specific challenges in your thought patterns and develop skills to respond to them more effectively' +
      ' One of the most common and effective forms of talk therapy.'
  },
  {
    title: 'Medication from licensed prescribers',
    description:
      'Explore medication options with a licensed prescriber who will determine whether a prescription is appropriate.'
  }
];

export const assessmentData = {
  assessmentScore: {
    title: 'Your depression score is:',
    description:
      'Experiencing symptoms is common. Cerebral can help you reduce and manage your symptoms so you feel better.',
    serviceLine: 'depression',
    buttonText: 'Continue'
  },
  assessmentTreatment: {
    title: 'Continue with basic info to see if treatment is right for you',
    description:
      'The professionals at Cerebral can provide a medical evaluation and appropriate treatment ' +
      'options to help you take control of your mental health.',
    ctaText: 'Continue',
    subscript: 'Next steps',
    treatmentOptions: DEPRESSION_TREATMENT_OPTIONS,
    cerebralRx: parseHtml(
      'With CerebralRx, medication is shipped directly to you and can cost up to <strong>80% less</strong> than retail prices.'
    ),
    image: {
      desktop: DesktopImage,
      mobile: MobileImage
    }
  },
  steps: [
    {
      title: 'Basic info',
      description:
        'Create your account with some basic information — name, contact info, and some context about your experience with mental health care.'
    },
    {
      title: 'Choose a treatment plan',
      description:
        'Learn more about therapy and medication services, then choose the treatment plan that is right for you. ' +
        'You can always change your plan later for any reason.'
    },
    {
      title: 'Choose a clinician + book a session',
      description:
        'See all available clinicians in your area by specialty and availability. You can read their bios, see their full calendars, and book your first session.'
    }
  ]
};
